import { default as socialMedia } from './socialMedia';

export default {
    ...socialMedia
};
